import { AppStore } from "rootReducer";

export const getActiveModal = (state: AppStore) => state.modalStore.activeModal;
